import React, { useState, useEffect } from "react";
import "../css/Panel_Certificados.css";

// Importamos tu archivo JSON con la nueva estructura de certificados
import listaCertificados from "../data/personas.json";

function Panel_Certificados() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedCertificado, setSelectedCertificado] = useState(null);
  const [isDirectQRAccess, setIsDirectQRAccess] = useState(false);

  // Captura la URL base actual de tu frontend
  const baseUrlFrontend = window.location.origin + window.location.pathname;

  useEffect(() => {
    // LÓGICA QR: Lee el ID desde la URL al cargar la página (?id=X)
    const queryParams = new URLSearchParams(window.location.search);
    const urlId = queryParams.get("id");

    if (urlId) {
      // Busca el certificado correspondiente en el JSON
      const certificadoDesdeUrl = listaCertificados.find(
        (c) => String(c.id) === String(urlId)
      );
      if (certificadoDesdeUrl) {
        setSelectedCertificado(certificadoDesdeUrl);
        setIsModalOpen(true);
        setIsDirectQRAccess(true); // Indica que se accedió directamente por QR
      }
    }
  }, []);

  const handleOpenModal = (certificado) => {
    console.log("Abriendo modal para:", certificado.nombre);
    setSelectedCertificado(certificado);
    setIsModalOpen(true);
    window.history.pushState({}, "", `?id=${certificado.id}`);
  };

  const handleCloseModal = () => {
    console.log("Cerrando modal");
    setIsModalOpen(false);
    setSelectedCertificado(null);
    window.history.pushState({}, "", window.location.pathname);
  };

  return (
    <div className="panelServicios">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700&display=swap');
        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: rgba(0, 0, 0, 0.6);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 9999;
          padding: 15px;
          box-sizing: border-box;
        }

        .modal-content {
          background: #ffffff;
          border-radius: 12px;
          padding: 0;
          width: 100%;
          max-width: 480px;
          max-height: 85vh;
          box-shadow: 0px 10px 30px rgba(0,0,0,0.5);
          position: relative;
          box-sizing: border-box;
          font-family: 'Roboto', sans-serif;
          display: flex;
          flex-direction: column;
          overflow: hidden;
        }

        .modal-inner-content {
          padding: 25px;
          flex: 1;
          overflow-y: auto;
        }

        .modal-body-container {
          display: flex;
          flex-direction: column;
          width: 100%;
        }

        /* Contenedores de imágenes centrados por defecto (Móvil) */
        .img-container-top, .img-container-bottom {
          text-align: center;
          width: 100%;
          margin: 8px 0;
          box-sizing: border-box;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .cert-img {
          max-width: 60px;
          height: auto;
          border-radius: 6px;
        }

        /* Botón cerrar ocupando todo el ancho de su contenedor */
        .btn-cerrar-modal {
          margin: 0;
          padding: 12px 25px;
          background-color: #222;
          color: #fff;
          border: none;
          border-radius: 0 0 12px 12px;
          cursor: pointer;
          width: 100%;
          font-weight: bold;
          font-size: 14px;
          box-sizing: border-box;
          display: block;
          flex-shrink: 0;
        }

        /* Ajustes para Vista de Escritorio / Tablet grande */
        @media (min-width: 1024px) {
          .modal-content {
            width: 50vw;
            max-width: none;
          }

          .modal-inner-content {
            padding-right: 160px;
          }

          .cert-img {
            max-width: 120px;
          }

          /* Imagen 1: Superior derecha debajo del título */
          .img-container-top {
            position: absolute;
            top: 80px;
            right: 25px;
            width: auto;
            margin: 0;
            text-align: left;
          }

          /* Imagen 2: Sector inferior derecho */
          .img-container-bottom {
            position: absolute;
            bottom: 85px;
            right: 25px;
            width: auto;
            margin: 0;
            text-align: left;
          }
        }

        .certificate-button {
          background: transparent;
          border: none;
          padding: 20px;
          cursor: pointer;
          width: 100%;
          text-align: left;
          font-family: inherit;
          font-size: inherit;
          color: inherit;
          padding-bottom: 0;
        }

        .certificate-button:active {
          opacity: 0.8;
        }
      `}</style>

      {/* Si se accedió directamente por QR, solo mostrar el modal sin el listado */}
      {/*{!isDirectQRAccess && (
        <div className="grupo_servicios">
          {Array.isArray(listaCertificados) && listaCertificados.length > 0 ? (
            listaCertificados.map((certificado, index) => {
              const qrLink = `${baseUrlFrontend}?id=${certificado.id}`;

              return (
                <button
                  key={`cert-${certificado.id}-${index}`}
                  className="certificate-button servicio_individual"
                  onClick={() => handleOpenModal(certificado)}
                  type="button"
                >
                  <div className="textoServicio">
                    <h1>{certificado.nombre}</h1>
                  </div>
                </button>
              );
            })
          ) : (
            <p style={{ padding: "20px", textAlign: "center", color: "#666" }}>
              No hay certificados disponibles
            </p>
          )}
        </div>
      )}*/}

      {/* Modal - Renderizado condicional simple */}
      {isModalOpen && selectedCertificado ? (
        <div
          className="modal-overlay"
          onClick={handleCloseModal}
          role="dialog"
          aria-modal="true"
        >
          <div
            className="modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-inner-content">
              {/* Cabecera del Documento */}
              <div style={{ textAlign: "center", marginBottom: "20px" }}>
                <h2
                  style={{
                    margin: "8px 0 0 0",
                    color: "#111",
                    fontSize: "20px",
                    lineHeight: "1.3",
                  }}
                >
                  {selectedCertificado.titulo}
                </h2>
              </div>

              {/* EN MOVIL: Imagen 1 centrada justo debajo del título */}
              {selectedCertificado.imagen_1 && (
                <div className="img-container-top">
                  <img
                    src={selectedCertificado.imagen_1}
                    alt="Imagen 1"
                    className="cert-img"
                  />
                </div>
              )}

              {/* Contenedor del cuerpo para estructurar el orden en móvil */}
              <div className="modal-body-container">
                
                {/* Datos del Titular */}
                <div
                  style={{
                    textAlign: "left",
                    color: "#333",
                    fontSize: "14px",
                    lineHeight: "1.6",
                  }}
                >
                  <p style={{ margin: "6px 0" }}>
                    <strong>Fecha Emisión:</strong>{" "}
                    {selectedCertificado.fechaEmision || "N/A"}
                  </p>
                  <p style={{ margin: "6px 0" }}>
                    <strong>Nombre:</strong> {selectedCertificado.nombre || "N/A"}
                  </p>
                  <p style={{ margin: "6px 0" }}>
                    <strong>RUT:</strong> {selectedCertificado.rut || "N/A"}
                  </p>
                  <p style={{ margin: "6px 0" }}>
                    <strong>Ha recibido la Certificación en:</strong> {selectedCertificado.certificacion || "N/A"}
                  </p>

                  {/* Sección de Dimensiones */}
                  {selectedCertificado.dimensiones &&
                  selectedCertificado.dimensiones.length > 0 ? (
                    <div style={{ marginTop: "15px" }}>
                      <h3
                        style={{
                          fontSize: "14px",
                          color: "#222",
                          marginBottom: "8px",
                          marginTop: "0",
                        }}
                      >
                        Acreditando el cumplimiento de los requisitos establecidos en las dimensiones de:
                      </h3>
                      <ul style={{ paddingLeft: "20px", margin: "0 0 20px 0" }}>
                        {selectedCertificado.dimensiones.map((dim, idx) => (
                          <li
                            key={idx}
                            style={{ marginBottom: "6px", fontSize: "13px" }}
                          >
                            <strong>{dim.nombre}</strong>
                          </li>
                        ))}
                      </ul>
                    </div>
                  ) : null}
                  
                  <div style={{ marginTop: "15px", marginBottom: "15px" }}>
                    <p style={{ margin: "6px 0" }}>
                      <strong>Intervalo de fechas de la acreditación:</strong>
                    </p>
                    <p style={{ margin: "6px 0" }}>
                      <strong>Desde:</strong> {selectedCertificado.conFecha || "N/A"}
                    </p>
                    <p style={{ margin: "6px 0" }}>
                      <strong>Hasta:</strong> {selectedCertificado.vigencia || "N/A"}
                    </p>
                  </div>
                </div>

                {/* EN MOVIL: Imagen 2 centrada al final de los datos */}
                {selectedCertificado.imagen_2 && (
                  <div className="img-container-bottom">
                    <img
                      src={selectedCertificado.imagen_2}
                      alt="Imagen 2"
                      className="cert-img"
                    />
                  </div>
                )}
              </div>
            </div>

            {/* Botón de salida que ocupa el 100% de ancho del modal */}
            <button
              onClick={handleCloseModal}
              className="btn-cerrar-modal"
              type="button"
            >
              Cerrar
            </button>
          </div>
        </div>
      ) : null}
    </div>
  );
}

export default Panel_Certificados;